import { TextField } from "../../../../utils/form";

const SurnameInput = ({ form: { control } }) => (
  <TextField control={control} fullWidth name="surname" label="Apellido" variant="outlined" required />
);

export default SurnameInput;